import { render, staticRenderFns } from "./shangpinxinxi.vue?vue&type=template&id=866c8bde&scoped=true&"
import script from "./shangpinxinxi.vue?vue&type=script&lang=js&"
export * from "./shangpinxinxi.vue?vue&type=script&lang=js&"
import style0 from "./shangpinxinxi.vue?vue&type=style&index=0&id=866c8bde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866c8bde",
  null
  
)

export default component.exports